module.exports = __webpack_public_path__ + "img/img4.b100625c.png";